import axios, { Axios, AxiosResponse } from "axios";
import { reporteDataDTO, ReporteDTO, reportePostulante } from "../interfaces/AYUDANTIAS/Reporte";
import { ResponseApi } from "../types/ResponseApi";

const localBack: string = process.env.REACT_APP_BACK || '';
const APIREPORTE: string = '/api/REPORTE';
const APICONSULTA: string = '/api/ConsultasInv';
const APIACAD : string = '/api/ConsultasAcademico'

export default class ReporteService {

    async GetReporteAyudantiasDeInvestigacionArchivos(token: any, idPeriodo: number, usuario: string, estado: string, tipoDoc: string): Promise<ResponseApi<ReporteDTO>> {
        const response: AxiosResponse<ResponseApi<ReporteDTO>> = await axios.get(`${localBack + APIREPORTE}/GenerarReporteAyudantiasInvestigacion/${idPeriodo}&${usuario}&${estado}&${tipoDoc}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        return response.data;
    }

    async GetReporteAyudantiasDeInvestigacionData(token: any, idPeriodo: number): Promise<ResponseApi<reporteDataDTO>> {
        const response: AxiosResponse<ResponseApi<reporteDataDTO>> = await axios.get(`${localBack + APICONSULTA}/GetSolicitudesAyudantiasInvestigacionByIdPeriodo/${idPeriodo}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        return response.data;
    }

    async GetReporteEstudiantesPostuladosData(token : any, idperiodo : number) : Promise<ResponseApi<reportePostulante>>{
        const response: AxiosResponse<ResponseApi<reportePostulante>> = await axios.get(`${localBack+APIACAD}/GetPostulantesAyudantiasInvestigacionByIdPeriodo/${idperiodo}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        return response.data;
    }

    async GetReporteEstudiantesPostuladosArchivo(token: any, idPeriodo: number, usuario: string,tipoDoc: string): Promise<ResponseApi<ReporteDTO>> {
        const response: AxiosResponse<ResponseApi<ReporteDTO>> = await axios.get(`${localBack + APIREPORTE}/GenerarReporteAyudantesInvestigacion/${idPeriodo}&${usuario}&${tipoDoc}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        return response.data;
    }



}